var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "x 1",
    clipPath: "url(#clip0_26_2993)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.57095 6.77566L15.5233 0H14.1133L8.94267 5.88201L4.81599 0H0.0551758L6.29689 8.89549L0.0551758 15.9999H1.4652L6.92196 9.78701L11.281 15.9999H16.0418M1.9741 1.04126H4.14029L14.1122 15.0098H11.9455",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_2993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9866,
    height: 16,
    fill: "white",
    transform: "translate(0.0551758)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXTwitterIcon);
export default __webpack_public_path__ + "static/media/x-twitter-icon.3700786018ca1a2d968651336789d08e.svg";
export { ForwardRef as ReactComponent };